export default {
  cloud_name: "de37ytcon",
  upload_preset: "futb6bhc",
};
